import type { RecordingEntry } from '@/app-shell/rpa/recorder/model/types';

/** Adds on-disk recordings without overwriting entries already tracked in this window. */
export function mergePersistedRecordings(
  current: readonly RecordingEntry[],
  persisted: readonly RecordingEntry[]
): readonly RecordingEntry[] {
  const bySessionId = new Map(current.map((entry) => [entry.sessionId, entry]));

  for (const entry of persisted) {
    if (!bySessionId.has(entry.sessionId)) {
      bySessionId.set(entry.sessionId, entry);
    }
  }

  return [...bySessionId.values()].sort((a, b) => b.createdAtMs - a.createdAtMs);
}
